import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
Wrapper.displayName = 'Wrapper';

export const Text = styled.p`
  font-size: 14.5px;
  color: ${({ confirmed }) => (confirmed ? '#1c4566' : '#53686f')}; 
  font-weight: ${({ confirmed }) => (confirmed ? '600' : 'normal')}; 
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    text-decoration: underline;
  }
`;
Text.displayName = 'Text';
